import React from 'react';
import { connect } from 'react-redux';
import { PatientCareCenterHome } from 'PatientCareCenter/Home';
import { PatientCareCenterPdf } from 'PatientCareCenter/Pdf';
import { PatientCareCenterNote } from 'PatientCareCenter/Note';
import { PatientCareCenterAl } from 'PatientCareCenter/Al';

class PatientContent extends React.Component {

    render() {
        switch (this.props.selectedTabType) {
            case 'HOME':
                return (<PatientCareCenterHome />);
            case 'PDF':
                return (<PatientCareCenterPdf id={this.props.pdfId}/>);
            case 'AL':
                return (<PatientCareCenterAl epno={this.props.epno} />);
            case 'IN':
                return (<PatientCareCenterNote />);
            default:
                return (<PatientCareCenterHome />);
        }
    }

}

function mapStateToProps(state) {
    let selectedTabType = state.ui.patientCenter[state.ui.patients.selectedPtno] && state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab] ?
        state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].type : '';
    let epno = -1;
    if (selectedTabType === 'AL') {
        let selectedTab = state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab;
        epno = parseInt(state.ui.patientTabs[selectedTab].id.split("_")[1]);
    }

    return {
        selectedTabType,
        epno,
        pdfId: state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab]?.id
    };
}

const connectedPatientContent = connect(mapStateToProps)(PatientContent);
export { connectedPatientContent as PatientContent };

